import { PermissionsStatusEnum, UserInviteStatusEnum } from '@quadminds/shared/commons';
import { LocalesCodeEnum, RoleSemanticNameEnum, VerificationStatusEnum } from '../../enums';

export interface IRoleNameSchema {
    semanticName: RoleSemanticNameEnum;
    name: string;
}
export interface IRoleSchema {
    id?: string;
    name?: IRoleNameSchema;
    permissions: IPermissionsSchema[];
}

export interface IPermissionsSchema {
    id?: string;
    name: string;
    code: string;
}

export interface IVerificationSchema {
    status: VerificationStatusEnum;
    timestamp: string;
    value: string;
    allowResend: boolean;
    allowResendMinutes: number;
}

export interface IUserSchema {
    id?: string;
    email: string;
    firstName: string;
    lastName?: string;
    phone?: string;
    settings?: Record<string, unknown>;
    status?: UserInviteStatusEnum;
    avatar?: string;
    permissionsStatus?: PermissionsStatusEnum;
    emailVerification?: IVerificationSchema;
    phoneNumberVerification?: IVerificationSchema;
    roles?: (IRoleSchema | undefined)[];
    inviteId?: string;
    businessArea?: string;
    isAdmin?: boolean;
    actions?: string;
    modules?: string[];
    locale?: LocalesCodeEnum;
    invitedBy?: string;
    invitedAt?: string;
    // Si el usuario logueado puede editar o eliminar este usuario o invitacion
    canManage?: boolean;
}
